import IDream from "motw_core/Entity/IDream";
import { dreamService } from "motw_core/Services/DreamService";
import { ShouldDreamBeReviewed } from "source/app/presentation/MainPanel/Dreams/Controls/Difficulty/ReviewIcon/DreamReviewIcon";
import { IsMasterDream } from "./DreamHelpers/IsMasterDream";
import { IDreamsState } from "./IDreamsState";
import { GetSearchedDreams } from "./GetSearchedDreams";

export class DreamFilter {
    static allFilters = [
        DreamFilter.filterBySearchText,
        // DreamFilter.filterByDifficulty,
        DreamFilter.filterByEmotion,
        DreamFilter.filterBySelectedAttributes,
        DreamFilter.filterByExcludedAttributes,
        DreamFilter.filterByMasterDreams,
        DreamFilter.filterByDreamsToReview,
        DreamFilter.filterByTodaysDreams,
        DreamFilter.filterByAdjacentDreams,
        DreamFilter.filterByCampaignId,
    ];

    public static filterBySearchText(dream: IDream, state: IDreamsState) {
        if (state.searchText === ``) {
            return true;
        }

        var searchedDreams = GetSearchedDreams(state);
        var result = searchedDreams.includes(dream);
        return result;
    }

    // private static filterByDifficulty(dream: IDream, state: IDreamsState) {
    //     const selectedDifficulty = state.selectedDifficulty;

    //     console.log(
    //         `[DreamFilter] selectedDifficulty is ${selectedDifficulty}`
    //     );

    //     // const filterResult = selectedDifficulty
    //     //     ? dream.difficulty <= state.selectedDifficulty
    //     //     : true;

    //     // return filterResult;

    //     return true;
    // }

    private static filterByEmotion(dream: IDream, state: IDreamsState) {
        const filterResult = state.selectedEmotion
            ? dream.emotion === state.selectedEmotion
            : true;

        return filterResult;
    }

    private static filterBySelectedAttributes(
        dream: IDream,
        state: IDreamsState
    ) {
        const filterResult =
            state.selectedAttributes.length === 0
                ? true
                : DreamFilter.DoesDreamHaveSelectedAttributes(
                      dream,
                      state.selectedAttributes
                  );

        return filterResult;
    }

    private static filterByExcludedAttributes(
        dream: IDream,
        state: IDreamsState
    ) {
        const filterResult =
            state.excludedAttributes.length > 0
                ? !DreamFilter.DoesDreamHaveSelectedAttributes(
                      dream,
                      state.excludedAttributes
                  )
                : true;

        return filterResult;
    }

    private static filterByMasterDreams(dream: IDream, state: IDreamsState) {
        const filterResult = state.onlyShowMasterDreams
            ? IsMasterDream(dream, state.sortedData)
            : true;

        return filterResult;
    }

    private static filterByDreamsToReview(dream: IDream, state: IDreamsState) {
        const filterResult = state.onlyShowDreamsToReview
            ? ShouldDreamBeReviewed(dream)
            : true;

        return filterResult;
    }

    private static filterByTodaysDreams(dream: IDream, state: IDreamsState) {
        const filterResult = state.onlyShowTodaysDreams
            ? dreamService.IsTodaysDream(dream)
            : true;

        return filterResult;
    }

    private static filterByAdjacentDreams(dream: IDream, state: IDreamsState) {
        const filterResult = state.onlyShowAdjacentDreams
            ? dreamService.IsAdjacentDream(dream)
            : true;

        return filterResult;
    }

    private static filterByCampaignId(dream: IDream, state: IDreamsState) {
        const filterResult = state.selectedCampaignId
            ? dream.linkid === state.selectedCampaignId ||
              dream.id === state.selectedCampaignId
            : true;

        return filterResult;
    }

    private static DoesDreamHaveSelectedAttributes(
        dream: IDream,
        attributes: string[]
    ): boolean {
        const filterResult =
            dream.attributes.filter((attribute) =>
                attributes.includes(attribute)
            ).length > 0;

        return filterResult;
    }
}
